import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { compose } from "redux";



import { getFiles, createFolder, renameFile, deleteFile } from "../../store/actions/filesActions";



import { FileManager } from "@cubone/react-file-manager";
import "./files.css";

function Files(props) {

    const { token, getFilesFN, files, createFolderFN, renameFileFN, deleteFileFN, department_id } = props;
    ////console.log("FILES PROPS: ", props);

    const [forceReRender, setForceReRender] = useState(false);


   const API_URL = process.env.NODE_ENV === 'production'

  ? "https://api.demo1.raborisk.ai"
  : "https://api.demo1.raborisk.ai";

    useEffect(() => {
        getFilesFN(department_id);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [department_id]);


    useEffect(() => {
        
        setForceReRender(false);
        setTimeout(() => {
            setForceReRender(true);
        }, 100);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [files]);


    const [currentPath, setCurrentPath] = useState("/");


    const onFileOpen = (file) => {

        //////console.log(file);
        if (file.isDirectory) {
            return setCurrentPath(file.path);
        }
        ////console.log("Current Path:", currentPath);
        window.open(file.s3_path, '_blank');
    }

    const onDownload = (files) => {
        ////console.log(files);
        for (let file of files) {
            window.open(file.s3_path, '_blank');
        }
    }

    const onDelete = (files) => {
        for (let file of files) {
            deleteFileFN(file.id, department_id);
        }
    }

    ////console.log(files);
    ////console.log("Current Path:", currentPath);
    ////console.log("Department: " ,department_id);

    // //console.log("File Upload Headers:", {
    //     Authorization: token,
    //     current_folder: currentPath || "/",
    //     department_id: String(department_id) || "1",
    // });

    return (

        <div className="p-4">

            {forceReRender &&
                <FileManager 
                onFileUploaded={() => getFilesFN(department_id)} 
                files={files} 
                enableFilePreview={false} 
                fileUploadConfig={{ url: API_URL + "/api/files/add_file", headers: { Authorization: token, "current_folder": currentPath || "/", department_id: String(department_id) || "1"} }} 
                onCreateFolder={(folderName) => createFolderFN(folderName, currentPath, department_id)} onRefresh={() => getFilesFN(department_id)} 
                onFileOpen={onFileOpen} 
                onDownload={onDownload} 
                onRename={(file, newName) => renameFileFN(file, newName, department_id)} 
                onDelete={onDelete} />
            }

        </div>

    )

}

const mapStateToProps = (state) => {
    console.log("Files", state.files)
    return {

        token: state.auth.token,
        files: state.files?.files



    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getFilesFN: (d) => dispatch(getFiles(d)),
        createFolderFN: (folderName, currentFolder, d) => dispatch(createFolder(folderName, currentFolder, d)),
        renameFileFN: (file, newName, d) => dispatch(renameFile(file, newName, d)),
        deleteFileFN: (id, d) => dispatch(deleteFile(id, d))

    };
};


export default compose(connect(mapStateToProps, mapDispatchToProps))(Files);
